<template>
  <div>
    <p class="sr-only">Liste over relaterede steder.</p>
    <strong v-if="relatedPlaces.length == 1">1 relateret sted: </strong>
    <strong v-else>{{ relatedPlaces.length }} relaterede steder: </strong>

    <template v-for="(r, index) in (renderLimit || relatedPlaces.length)">
      <span class="related-place-span">
        <router-link :to="{path: '/tag/'+relatedPlaces[index].primaryTag.id+'/place/'+relatedPlaces[index].id}">{{ relatedPlaces[index].name+' ('+relatedPlaces[index].primaryTag.name+') | '}}</router-link>
      </span>
    </template>

    <div v-if="relatedPlaces.length > 4">
      <div class="filter-btn show-all-related" @click="showAllRelatedPlaces" v-if="renderLimit">
        <span>Vis alle steder</span>
        <span class="material-icons" aria-hidden="true">expand_more</span>
      </div>

      <div class="filter-btn show-all-related" @click="showAllRelatedPlaces" v-else>
        <span>Vis færre steder</span>
        <span class="material-icons" aria-hidden="true">expand_less</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      renderLimit: 0,
      maxLimit: 0,
    }
  },
  props: {
    relatedPlaces: {
      type: Array,
      required: true
    },
  },
  watch: {
    relatedPlaces() {
      this.setLimit();
    }
  },
  created() {
    this.setLimit();
  },
  methods: {
    setLimit() {
      this.maxLimit = this.$props.relatedPlaces.length < 4 ? this.$props.relatedPlaces.length : 4;
      this.renderLimit = this.maxLimit;
    },
    showAllRelatedPlaces() {
      if(!this.renderLimit) {
        this.renderLimit = this.maxLimit;
      }
      else {
        this.renderLimit = null;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .show-all-related {
    border-top: none;
    text-align: center;
    cursor: pointer;
  }

  .show-all-related .material-icons {
    vertical-align: middle;
  }

</style>
